window.initializeDatepickerElement = () => {
  class DatepickerCustom extends HTMLElement {
    connectedCallback() {
      const self = this;
      const field = self.querySelector(".datepicker-input");
      const overlay = self.querySelector(".overlay-input");
      const today = new Date();

      // eslint-disable-next-line
      const datepicker = new Datepicker(field, {
        // eslint-disable-line
        minDate: today,
        format: "yyyy-mm-dd",
        autohide: true,
        showOnFocus: false,
      });

      field.addEventListener("changeDate", (event) => {
        const selectedDate = event.detail.date;
        const date = new Date(selectedDate);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const formattedDate = `${month}/${day}/${year}`;

        overlay.value = formattedDate;
      });
    }
  }
  customElements.define("datepicker-custom", DatepickerCustom);
};
